(function () {

    "use strict";

    function datepickerController() {

    }

    datepickerController.$inject = [];

    angular.module("sphforms.main")
        .component("sphFormsDatepicker", {
            controller: datepickerController,
            bindings: {
                nameLabel: "=",
                model: "=",
                disable: "="
            },
            templateUrl: "modules/main/components/ui/datepicker/datepicker.template.html"
        });

}());
